import { render, staticRenderFns } from "./mainListAMS.vue?vue&type=template&id=2b6e2c9a"
import script from "./mainListAMS.vue?vue&type=script&lang=js"
export * from "./mainListAMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports